<template>
  <div>
    <div id="menu-close-btn" class="menu-close-btn ssm-toggle-nav">
      <svg width="18" height="18" class="l-header__btn-menu--close">
        <use xlink:href="#ic-icon-close" />
      </svg>
    </div>
    <nav class="l-nav-header">
      <ul class="l-nav-header__nav">
        <li class="font-bold">
          <router-link to="/account/selectstore">
            <span><img src="/assets/images/icon/menu/select-shop.svg" /></span>
            <p>店舗を切り替える</p>
          </router-link>
        </li>
        <div class="counter-block-item js-counter-block" v-show="showCounterBlock">
          <a href="#" class="l-header__control">
            <div class="c-percent-circle">
              <svg viewBox="0 0 36 36" class="c-percent-circle__circular">
                <path class="c-percent-circle__circular--bg"
                  d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
                <path class="c-percent-circle__circular--circle" :stroke-dasharray='(counterBlock ? counterBlock : 0) + ", 100"' d="M18 2.0845
                  a 15.9155 15.9155 0 0 1 0 31.831
                  a 15.9155 15.9155 0 0 1 0 -31.831" />
                <text x="18" y="23.35" class="c-percent-circle__percentage">
                  {{ counterBlock ? counterBlock : 0 }}
                </text>
              </svg>
            </div>
          </a>
          <span class="font-bold">
            混雑状況
            <b class="c-percent-circle__percentage">
              {{ counterBlock ? counterBlock : 0 }}%
            </b>
          </span>
        </div>
        <div v-for="(menu, index) in MENU" :key="index">
          <div class="title-menu">{{ menu.title }}</div>
          <li v-for="item in menu.items" :key="item.name" :class="{ 'd-none': item.hidden, 'contact_link': item.class == 'contact_link' }">
            <router-link :to="item.link">
              <span>
                <img :src="item.icon"/>
                  <div v-if="item.countUnred" class="badge-unread">
                  {{ item.countUnred }}
                  </div>
              </span>
              <p>{{ item.name }}</p>
            </router-link>
          </li>
        </div>
        <div class="l-nav-header__sub_nav mb-15">
          <router-link to="/about"> このアプリについて</router-link>
          <router-link to="/about/privacy">プライバシーポリシー</router-link>
          <router-link to="/about/environment">環境・社会貢献</router-link>
          <router-link to="/about/company">イオンタウン株式会社</router-link>
        </div>
      </ul>
    </nav>
    <modal_congestion_situation :counter-blocks=counterBlocks></modal_congestion_situation>
  </div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import { isShowCounterBlock, isShowFloorGuide } from "../store/firestore";
import { Tenant } from "../plugin/mixin.js";
import ModalCongestionSituation from "./ModalCongestionSituation.vue";
import { mapState } from "vuex";
export default Vue.extend({
  name: 'menuApp',
  components: {
    'modal_congestion_situation': ModalCongestionSituation
  },
  mixins: [Tenant],
  data() {
    return {
      showCounterBlock: false,
      showFloorGuide: false,
    }
  },
  computed: {
    ...mapState({
      campaignCount: state => state.footerLotterCount,
      couponCount: state => state.footerCouponCount
    }),
    MENU() {
      return [
        {
          title: 'Menu',
          items: [
            {
              name: 'ホーム',
              link: '/top',
              icon: '/assets/images/icon/menu/icon-home.svg'
            },
            {
              name: 'ショップ',
              link: '/shop/list',
              icon: '/assets/images/icon/menu/icon-shop.svg'
            },
            {
              name: 'モバイルオーダー',
              link: '/mobileorder',
              icon: '/assets/images/icon/menu/icon-mobile-order.svg',
              hidden: !this.isMobileOrderEnabled()
            },
            {
              name: 'ショップニュース',
              link: '/news',
              icon: '/assets/images/icon/menu/icon-noti.svg'
            },
            {
              name: 'クーポン',
              link: '/coupons',
              icon: '/assets/images/icon/menu/icon-coupon.svg',
              countUnred: this.couponCount > 99 ? '99+' : this.couponCount
            },
            {
              name: 'イベント',
              link: '/events',
              icon: '/assets/images/icon/menu/icon-calendar.svg'
            },
            {
              name: 'チラシ',
              link: '/store/flyer',
              icon: '/assets/images/icon/menu/icon-flyer.svg'
            },
            {
              name: '抽選会',
              link: '/campaign/list',
              icon: '/assets/images/icon/menu/icon-lottery.svg',
              countUnred: this.campaignCount > 99 ? '99+' : this.campaignCount
            },
            {
              name: 'フロアガイド',
              link: '/store/floorguide',
              icon: '/assets/images/icon/menu/icon-map.svg',
              hidden: !this.showFloorGuide
            },
            {
              name: 'アクセス・施設案内',
              link: '/store/location',
              icon: '/assets/images/icon/menu/icon-building.svg'
            }
          ]
        },
        {
          title: 'My Page',
          items: [
            {
              name: 'マイページ',
              link: '/account/profile',
              icon: '/assets/images/icon/menu/icon-account.svg'
            }
          ]
        },
        {
          title: 'Support',
          items: [
            {
              name: 'お問い合わせ',
              link: '#',
              icon: '/assets/images/icon/menu/icon-mail.svg',
              class: 'contact_link'
            },
            {
              name: 'ヘルプ',
              link: '/help',
              icon: '/assets/images/icon/menu/icon-question.svg'
            },
          ]
        }
      ]
    }
  },
  async created() {
    const shopId = this.$store.state.shopId;
    this.showCounterBlock = await isShowCounterBlock(shopId);
    this.showFloorGuide = await isShowFloorGuide(shopId);
  },
  mounted() {
    const $ = window.$;
    $('.l-nav-header').slideAndSwipe();
  },
})
</script>

<style scoped>
.menu-close-btn {
  position: fixed;
  top: 15px;
  left: 322px;
  z-index: 9999;
  background: transparent;
  border: none;
  padding-inline: clamp(0.5rem, 3vw, 1rem);;
  transform: translateX(100%);
  transition: transform 0.25s ease-in-out;
  pointer-events: none;
  opacity: 0;
}

.menu-close-btn.ssm-nav-visible {
  transform: translateX(0);
  pointer-events: auto;
  opacity: 1;
}

#menu-close-btn {
  display: none;
}

.menu-close-btn .l-header__btn-menu--close {
  display: block;
}

html.is-navOpen #menu-close-btn {
  display: block;
}

@media only screen and (max-width: 365px) {
  .menu-close-btn {
    left: 287px;
  }
}

@media only screen and (max-width: 320px) {
  .menu-close-btn {
    left: 267px;
  }
}

</style>
